<script lang="ts" setup>
  import { computed, onMounted, ref, toRefs } from 'vue'

  import type { EffortJsonldVueGlobalSearchDefaultReadSync, EmployeeNotificationJsonldDefaultRead } from '@/api'
  import { useGeneratedEffortStore } from '@/stores'
  import EffortLink from '@/elements/EffortLink.vue'
  import PageLoading from '@/components/PageLoading.vue'

  interface Props {
    notification: EmployeeNotificationJsonldDefaultRead
  }

  interface Data {
    effort: number
    note: number
    author: string
  }

  const props = defineProps<Props>()
  const { notification } = toRefs(props)

  const data = computed<Data>(() => notification.value.data as unknown as Data)
  const effort = ref<EffortJsonldVueGlobalSearchDefaultReadSync>()
  const loading = ref(true)

  onMounted(async () => {
    effort.value = await useGeneratedEffortStore()
      .fetchByIri('/api/efforts/' + data.value.effort)
      .then((response) => response.value)
    loading.value = false
  })
</script>

<template>
  <div>
    <PageLoading v-if="loading" />
    <div v-else>
      <span class="text-sm font-semibold leading-6">{{ data.author }} hat Sie in einem Kommentar erwähnt:</span>
      <EffortLink
        v-if="effort"
        :id="effort.id"
        fetch-title
        show-id
        no-icon />
    </div>
  </div>
</template>
